import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Section List
export const getSectionList = createAsyncThunk(
  "getSectionList",
  async (
    { search, pageLimit, pageCount, sort_by, sort_direction },
    { rejectWithValue },
  ) => {
    try {
      let queryParams = [];

      if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
      if (pageCount) queryParams.push(`page=${pageCount}`);
      if (pageLimit) queryParams.push(`limit=${pageLimit}`);
      if (sort_by) queryParams.push(`sortBy=${sort_by}`);
      if (sort_direction) queryParams.push(`sortOrder=${sort_direction}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await AxiosApi.get(
        `section/getAllSections${queryString}`,
      );
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

// Create Edit Section
export const createSection = createAsyncThunk(
  "createSection",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`section/getSectionData`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateSection = createAsyncThunk(
  "updateSection",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`section/updateSection/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message);
      return rejectWithValue(error.response?.data);
    }
  },
);

// Delete Section
export const deleteSection = createAsyncThunk(
  "deleteSection",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`section/deleteSection/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  },
);

const sectionSlice = createSlice({
  name: "sections",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // Get Section List
      .addCase(getSectionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSectionList.fulfilled, (state, action) => {
        state.loading = false;
        state.getSectionListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSectionList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      //create Section
      .addCase(createSection.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSection.fulfilled, (state, action) => {
        state.loading = false;
        state.createSectionStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createSection.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Delete Section
      .addCase(deleteSection.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSection.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteSectionStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteSection.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = sectionSlice;
export default reducer;
